module.exports = "<h2 class=\"text-muted\">QR Codes</h2>"